export enum PageType {
  Home = 'Home',
  Browse = 'Browse',
  Product = 'Product',
  Promo = 'Promo',
  Release = 'Release',
  Release2 = 'Release2',
  Other = 'Other',
  Search = 'Search Results',

  Terms = 'Terms',
  Privacy = 'Privacy',
  Favorites = 'Account (Favorites)',
  Following = 'Account (Following)',
  Portfolio = 'Account (Portfolio)',
  Selling = 'Account Selling',
  Doppelganger = 'Doppelganger',
}
